import React from "react";

const withNotifier = (ComposedComponent) =>
  class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        notification: {
          visible: false,
          type: null,
          message: "",
        },
      };

      this.notification = this.onNotification.bind(this);
    }

    onNotification(message, type = null, timeout = 2000) {
      let notification = this.state.notification;
      notification.visible = true;
      notification.message = message;
      notification.type = type;
      this.setState({ notification });
    }

    render() {
      let Notification = {
        visible: this.state.notification.visible,
        message: this.state.notification.message,
        type: this.state.notification.type,
        onNotification: this.onNotification.bind(this),
      };

      return <ComposedComponent {...this.props} notification={Notification} />;
    }
  };

export default withNotifier;
